import { dataEyeTracking } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyeTracking = /*#__PURE__*/createIcon(dataEyeTracking)
export default IconEyeTracking
